import React, {
  FC, useState, useRef, useEffect,
} from 'react';
import { getWindowWidth, isMobile } from '../../../../../../../lib/utils/utils';
import InterMediumText from '../../../../../../../components/Text/InterMediumText';
import InterBoldText from '../../../../../../../components/Text/InterBoldText';
import PingFangMediumText from '../../../../../../../components/Text/PingFangMediumText';
import { Building3pdVO } from '../../../../../../../lib/types';

const Building: FC<Props> = ({
  isEnglish,
  formError,
  buildingList,
  buildingId,
  setBuildingId,
}) => {
  const inputWidth = isMobile() ? getWindowWidth() - 40 : 400;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const selectedBuilding = buildingList.find(b => b.buildingId === buildingId);
  const displayValue = selectedBuilding?.buildingName || '';

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div style={{ marginTop: 30 }}>
      <div style={{ width: isMobile() ? getWindowWidth() - 40 : 400, marginLeft: 'auto', marginRight: 'auto', textAlign: 'center' }}>
        {
          isEnglish ? (
            <InterMediumText fontSize={16} lineHeight={22}>
              Building/Complex<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
            </InterMediumText>
          ) : (
            <PingFangMediumText fontSize={16} color={'#000000'}>
              建筑物/综合楼<InterBoldText color={'#F44336'} fontSize={20} isSpan={true}>*</InterBoldText>
            </PingFangMediumText>
          )
        }
      </div>

      {/* 选择建筑物 */}
      <div ref={dropdownRef} style={{ position: 'relative', marginLeft: 'auto', marginRight: 'auto', width: inputWidth }}>
        <div
          onClick={() => setIsOpen(!isOpen)}
          style={{
            height: 60,
            width: inputWidth,
            marginLeft: 'auto',
            marginRight: 'auto',
            alignItems: 'center',
            backgroundColor: 'rgba(228, 228, 228, 0.5)',
            borderRadius: 5,
            marginTop: 10,
            display: 'flex',
            justifyContent: 'center',
            cursor: 'pointer',
            border: formError && !buildingId ? '1px solid #F44336' : 'none',
          }}
        >
          <span
            style={{
              fontSize: '18px',
              fontFamily: 'Inter-Regular, Inter',
              fontWeight: 400,
              color: buildingId ? '#000000' : 'rgba(0, 0, 0, 0.5)',
              lineHeight: '35px',
              textAlign: 'center',
              width: inputWidth - 40,
            }}
          >
            {displayValue || (isEnglish ? 'Select building' : '选择建筑物')}
          </span>
          <div
            style={{
              position: 'absolute',
              right: 15,
              top: '50%',
              transform: `translateY(-50%) rotate(${isOpen ? 180 : 0}deg)`,
              transition: 'transform 0.2s ease',
            }}
          >
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
              <path d="M1 1L6 6L11 1" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        {isOpen && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: '#FFFFFF',
              borderRadius: 5,
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              zIndex: 1000,
              maxHeight: '300px',
              overflowY: 'auto',
              marginTop: 5,
            }}
          >
            {buildingList.map((building) => (
              <div
                key={building.buildingId}
                onClick={() => {
                  setBuildingId(building.buildingId);
                  setIsOpen(false);
                }}
                style={{
                  padding: '12px 16px',
                  fontSize: '16px',
                  fontFamily: 'Inter-Regular, Inter',
                  fontWeight: 400,
                  color: '#000000',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease',
                  borderBottom: building.buildingId !== buildingList[buildingList.length - 1].buildingId ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(228, 228, 228, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                {building.buildingName}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export interface Props {
  isEnglish: boolean;
  formError: boolean;
  buildingList: Building3pdVO[];
  buildingId?: number;
  setBuildingId: (id: number) => void;
}

export default Building;
